import React from 'react'
import Button from '@mui/material/Button'
import { IQDialog } from '../../common'
import { Stack } from '@mui/material'

interface IProps {
  title?: string
  buttonName?: string
  content: string | React.ReactNode
  dataTestId?: string
  isShow: boolean
  onClose: () => void
  onCancel: () => void
}

export const CancelAlertNew = ({ title, content, dataTestId, isShow, buttonName, onClose, onCancel }: IProps) => (
  <IQDialog
    isShow={isShow}
    title={title || ''}
    content={content}
    actions={
      <Stack
        direction='row'
        spacing={1}
        justifyContent='space-between'
        sx={{ width: '100%' }}
      >
        <Button
          variant='outlined'
          onClick={onClose}
          data-testid={`${dataTestId}-cancel`}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          onClick={onCancel}
          data-testid={`${dataTestId}-cancel-ok`}
        >
          {buttonName ?? 'OK'}
        </Button>
      </Stack>
    }
    onClose={onClose}
    testPrefix={`${dataTestId}-cancel`}
  />
)
